import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';

import styled, {createGlobalStyle, css} from 'styled-components';

import PrevIcon from '../../../../assets/icons/secondary/Arrow - Left.svg';
import NextIcon from '../../../../assets/icons/secondary/Arrow - Right.svg';
import CloseIcon from '../../../../assets/icons/secondary/Close.svg';
import DownloadIcon from '../../../../assets/icons/secondary/Download.svg';
import EnterFullscreenIcon from '../../../../assets/icons/secondary/Full screen enter.svg';
import ExitFullscreenIcon from '../../../../assets/icons/secondary/Full screen exit.svg';
import ZoomInIcon from '../../../../assets/icons/secondary/Zoom In.svg';
import ZoomOutIcon from '../../../../assets/icons/secondary/Zoom Out.svg';
import {getFontWeight, getRem, ms, square} from '../../../../styles';
import {View} from '../../../../uikit/View';
import {envManager} from '../../../../utils/env';

const iconStyle = css`
  ${square(24)};
  fill: currentcolor;
`;

const SCloseIcon = styled(CloseIcon)`
  ${iconStyle};
  ${square(30)};
`;

const SZoomInIcon = styled(ZoomInIcon)`
  ${iconStyle};
`;

const SZoomOutIcon = styled(ZoomOutIcon)`
  ${iconStyle};
`;

const SEnterFullscreenIcon = styled(EnterFullscreenIcon)`
  ${iconStyle};
`;

const SExitFullscreenIcon = styled(ExitFullscreenIcon)`
  ${iconStyle};
`;

export const PrevNextIconContainer = styled(View)`
  ${square(44)};
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
`;

const SPrevIcon = styled(PrevIcon)`
  ${iconStyle};
`;

const SNextIcon = styled(NextIcon)`
  ${iconStyle};
`;

const SDownloadIcon = styled(DownloadIcon)`
  ${iconStyle};
`;

export {
  SCloseIcon as CloseIcon,
  SDownloadIcon as DownloadIcon,
  SEnterFullscreenIcon as EnterFullscreenIcon,
  SExitFullscreenIcon as ExitFullscreenIcon,
  SNextIcon as NextIcon,
  SPrevIcon as PrevIcon,
  SZoomInIcon as ZoomInIcon,
  SZoomOutIcon as ZoomOutIcon,
};

export const Document = {
  Container: styled(View)<{isSingle?: boolean}>`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${ms(62)} ${ms(72)};

    iframe {
      width: 100%;
      height: 100%;
      border: none;
      background-color: #fff;
    }

    @media (max-width: 768px) {
      padding: ${ms(52)} ${ms(24)};
    }
  `,
  LoadingSpinnerContainer: styled(View)`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
};

export const GlobalStyles = createGlobalStyle<{topPosition?: number}>`
  .yarl__root {
    ${() =>
      envManager.isB2bWidget &&
      css`
        position: absolute;
      `}
  }

  .yarl__container {
    background-color: rgba(0, 0, 0, 0.6);
  }

  .yarl__toolbar {
    padding: 0;
    top: 4px;
  }

  .yarl__icon {
    ${square(24)};
  }

  .yarl__navigation_next,.yarl__navigation_prev {
    filter: none;
  }

  .yarl__slide_title {
    font-family: inherit;
    font-size: ${getRem(16)};
    font-weight: ${getFontWeight('regular')};
  }
`;
